import moment from "moment";

/**
 * Calendar month helpers for history paging (inclusive start/end of month).
 */

export function getMonthRange(date = new Date()) {
  const m = moment(date);
  return {
    start: m.clone().startOf("month").toDate(),
    end: m.clone().endOf("month").toDate(),
    year: m.year(),
    month: m.month(), // 0-based
    key: m.format("YYYY-MM"),
  };
}

export function monthKeyFromParts(year, monthIndex) {
  return moment({ year, month: monthIndex, day: 1 }).format("YYYY-MM");
}

export function getMonthRangeFromKey(key) {
  const m = moment(key, "YYYY-MM");
  return {
    start: m.clone().startOf("month").toDate(),
    end: m.clone().endOf("month").toDate(),
    year: m.year(),
    month: m.month(),
    key: m.format("YYYY-MM"),
  };
}

export function shiftMonthKey(key, deltaMonths) {
  return moment(key, "YYYY-MM").add(deltaMonths, "months").format("YYYY-MM");
}

export function isSameMonthKey(date, key) {
  if (!date || !key) return false;
  return moment(date).format("YYYY-MM") === key;
}
